<template>
    <div class="print">
        <p style="text-align:right;text-indent: 2em;">
        Приложение N 2<br/>
        Утверждено
        приказом Министерства здравоохранения<br/>
        Российской Федерации<br/>
        от 12 ноября 2021 г. N 1051н
        </p>
        <p style="text-align:center;font-weight:bold;">Информированное добровольное согласие на медицинское вмешательство</p>
        <p style="text-align:justify;margin-bottom: 0;">
            Я, {{ patient.full_name}}, {{ patient.birthdate }} г. рождения, {{ patient.sex == "m" ? 'зарегистрированный' : 'зарегистрированная' }} по адресу: {{ patient.address}}, 
            {{ patient.sex == "m" ? 'проживающий' : 'проживающая' }} по адресу:
            ________________________________________________________________________________________________
            в отношении ________________________________________________________________________________ 
            "__" ____________________________ ____ г. рождения, проживающего по адресу: 
            ___________________________________________________________________________ даю информированное добровольное согласие на виды медицинских вмешательств, 
            включенные в Перечень определенных видов медицинских вмешательств, на которые граждане дают информированное добровольное согласие при выборе врача и 
            медицинской организации для получения первичной медико-санитарной помощи, утвержденный приказом Министерства здравоохранения и социального развития 
            Российской Федерации от 23 апреля 2012 г. N 390н <1> (далее - виды медицинских вмешательств, включенных в Перечень), для получения первичной медико-санитарной 
            помощи/получения первичной медико-санитарной помощи лицом, законным представителем которого я являюсь (ненужное зачеркнуть) в 
            Общество с ограниченной ответственностью «Клиника Профессора».
        </p>
        <p style="text-align:left;margin-bottom: 0;">
            Медицинским работником: 
            ________________________________________________________________________________________________ 
        </p>
        <p style="text-align:justify;margin-bottom: 0;">
            в доступной для меня форме мне разъяснены цели, методы оказания медицинской помощи, связанный с ними риск, возможные варианты медицинских вмешательств, 
            их последствия, в том числе вероятность развития осложнений, а также предполагаемые результаты оказания медицинской помощи. Мне разъяснено, что я имею 
            право отказаться от одного или нескольких видов медицинских вмешательств, включенных в Перечень, или потребовать его (их) прекращения, за исключением 
            случаев, предусмотренных частью 9 статьи 20 Федерального закона от 21 ноября 2011 г. N 323-ФЗ "Об основах охраны здоровья граждан в Российской Федерации". 
            Сведения о выбранном (выбранных) мною лице (лицах), которому (которым) в соответствии с пунктом 5 части 5 статьи 19 Федерального закона от 21 ноября 2011 г. 
            N 323-ФЗ "Об основах охраны здоровья граждан в Российской Федерации" может быть передана информация о состоянии моего здоровья или состоянии лица, законным 
            представителем которого я являюсь (ненужное зачеркнуть), в том числе после смерти:
        </p>
        <p style="text-align:center;line-height:1rem">
        ________________________________________________________________________________________________
        (фамилия, имя, отчество (при наличии) гражданина, контактный телефон)
        </p>
        <p style="text-align:center;line-height:1rem">
        ________________________________________________________________________________________________
        (фамилия, имя, отчество (при наличии) гражданина, контактный телефон)
        </p>
        <p style="text-align:center;line-height:1rem">
        ______________&nbsp;{{ patient.full_name}}
        </p>
        <p style="text-align:center;line-height:1rem">
        ________________________&nbsp;_______________________________________________________________________
        (подпись)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(фамилия, имя, отчество (при наличии) медицинского работника)
        </p>

        <p style="text-align:right;line-height:1rem">{{ date }} г.</p>
        <p style="text-align:right;line-height:1rem">(дата оформления)</p>
    </div>
</template>
<script>
export default {
    props: ['patient','date'],
    computed: {
        passport() {
            if (this.$isJSON(this.patient.passport)) {
                let p = JSON.parse(this.patient.passport)
                return 'серия ' + p.series + ' номер ' + p.number + ' выдан ' + p.issued + ' ' + p.date
            }else{
                return this.patient.passport.length>0 ? this.patient.passport : 'не указаны'
            }
      }
    }
}
</script>